import { Snackbar, SnackbarContent } from '@mui/material';
import { FC, memo, useContext, useMemo, useState, useEffect } from 'react';
import LicenseContext from 'src/contexts/LicenseContext';
import arrayUtil from 'src/utils/array.util';

const AsyncJobSnackbar: FC = memo(() => {
  const licenseContext = useContext(LicenseContext);
  const [title, setTitle] = useState('');

  const dict = useMemo(() => ({
    InsertOrdersJob: '案件インポート',
    DuplicateSpecificDayJob: '配送計画・案件複製',
    'Caritec::DispatchTableImportJob': '配車表取込',
  }), []);

  useEffect(() => {
    if (!licenseContext) return;

    const jobNames = licenseContext.asyncJobs.map((it) => (dict[it.jobName] || it.jobName) as string);
    setTitle(arrayUtil.uniq(jobNames).join('、'));
  }, [dict, licenseContext]);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={licenseContext.asyncJobRequested}
      key="DuplicatingSnackbar"
    >
      <SnackbarContent
        message={`${title}処理を実行中です（残り${licenseContext.asyncJobs.length > 0 ? licenseContext.asyncJobs.length.toLocaleString() : '-'}件）。`}
        sx={{
          backgroundColor: 'grey.800',
          color: 'common.white',
        }}
      />
    </Snackbar>
  );
});

export default AsyncJobSnackbar;
